import { useState, useEffect } from "react";
import { calculateDevice, debounce } from "../utils/helpers";

/**
 *
 * @returns {{ isDesktop: Boolean, isMobile: Boolean, isTablet: Boolean, height: Number, width: Number }} Returns the device type, height and width of the window
 */
function getSize() {
  return {
    dimensions: { height: window.innerHeight, width: window.innerWidth },
    ...calculateDevice({ height: window.innerHeight, width: window.innerWidth }),
  };
}

/**
 * Hook that dynamic returns the device type, height and width of the `window`.
 * Updates upon trigger of the window resizing (EventListener).
 * @returns {{ isDesktop: Boolean, isMobile: Boolean, isTablet: Boolean, height: Number, width: Number }} returns the height and width of the window
 */
export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    // Debounce to avoid the function fire multiple times
    const handleResize = debounce(function handleResize() {
      setWindowSize(getSize());
    }, 150);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
